import * as React from "react";

export default class LoginUtility {

    private static count: number = 0;


    public static IncrementLoginAttempt() {
        ++LoginUtility.count;
    }

    public static GetLoginAttemptCount() {
        return LoginUtility.count;
    }

    public static ResetLoginAttemptCount() {
        LoginUtility.count = 0;
    }

}
